var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 6H8.00002C6.89498 6 6.00998 6.89498 6.00998 8.00002L6 22C6 23.105 6.89498 24 8.00002 24H22C23.105 24 24 23.105 24 22V8.00002C24 6.89498 23.105 6 22 6ZM21 17H17V21H13V17H9V13H13V9H17V13H21V17Z",
    id: "icon"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitals);
export default __webpack_public_path__ + "static/media/hospitals.8b5ac1b0.svg";
export { ForwardRef as ReactComponent };